import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, theme } from '@olxbr/design-system'
import { Button } from '@olxbr/ds-core'

import Svg from '../../atoms/Svg'
import Touchable from '../../atoms/Touchable'

const Option = styled(Button)`
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-style: solid;
  border-color: #e5e5e5;
  border-width: 1px;
  border-radius: 8px;
  padding: ${props => (props.compact ? '16px' : '32px')};
  ${props => (props.last ? '' : `margin-bottom: 16px;`)}

  ${props =>
    props.compact &&
    `
    .olx-button__icon-wrapper {
      margin-right: 16px;
    }
  `}
`

const IconArea = styled(View)`
  display: flex;
  min-width: 32px;
  min-height: 32px;
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  background-color: #f0e6ff;
`

const HelpOption = ({ onClick, svgPath, icon, text, last, compact }) => (
  <Touchable onClick={onClick}>
    <Option last={last} compact={compact} size="large" variant="neutral" className="w-full">
      {icon || (
        <IconArea>
          <Svg
            width={16}
            height={16}
            svgPath={svgPath}
            color={theme.colors.purple}
            viewBox="0 0 24 24"
          />
        </IconArea>
      )}
      <span className="typo-body-small font-semibold">{text}</span>
    </Option>
  </Touchable>
)

HelpOption.propTypes = {
  onClick: PropTypes.func,
  svgPath: PropTypes.string,
  icon: PropTypes.node,
  text: PropTypes.string.isRequired,
  last: PropTypes.bool,
  compact: PropTypes.bool,
}

export default HelpOption
